import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { padding: number }>(
  {
    root: {
      overflow: 'hidden',
      padding: ({ padding }) => padding,
    },
    itemContainer: {
      maxWidth: '100%',
      display: 'flex',
      transition: 'all 0.5s ease-out',
    },
    item: {
      flexBasis: '100%',
      flexShrink: 0,
      marginRight: ({ padding }) => padding,
    },
    bullets: {
      listStyleType: 'none',
      display: 'flex',
      gap: 8,
      justifyContent: 'center',
      marginTop: 40,
    },
  },
  { name: 'generic-carousel' },
);

export default useStyles;
